import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter
} from "react-icons/ai";
import { FaLinkedinIn, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          Sarveen Rajendran
        </Col>
        <Col md="4" className="footer-copywright">
          Copyright © {year}
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/sarveen-rajendran/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="linkedin"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="mailto:sarveen.work@gmail.com"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="mail"
              >
                <FaEnvelope />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://wa.me/60194509958"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="whatsapp"
              >
                <FaWhatsapp />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer